import { render, staticRenderFns } from "./providerform.vue?vue&type=template&id=6c4f2353&scoped=true"
import script from "./providerform.vue?vue&type=script&lang=js"
export * from "./providerform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4f2353",
  null
  
)

export default component.exports